<template>
  <nav class="nav">
    <a
      :href="titleLink"
      class="nav__nav-link--main"
      :class="{
        'nav__nav-link--no-margin': hasNoMargin
      }"
      >{{ title }}</a
    >
    <div
      :class="{
        'nav__nav-multicolumn': multiColumn
      }"
    >
      <a
        v-for="item in items"
        :key="item.name"
        :href="item.hasAbsoluteLink ? item.link : getLinkPrefix + item.link"
        class="nav__nav-link"
        >{{ item.name }}</a
      >
    </div>
  </nav>
</template>

<script>
import { siteLink } from "@/constants/links";

export default {
  name: "BaseNav",
  props: {
    title: {
      type: String,
      default: "",
      required: true
    },
    titleLink: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    multiColumn: {
      type: String,
      default: ""
    },
    hasNoMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLinkPrefix() {
      return this.$store.state.isMobile ? siteLink.mobile : siteLink.desktop;
    }
  }
};
</script>

<style scoped lang="scss">
.nav {
  @include grid-custom-columns-ie11-fix(4 1 1 2 3);

  margin-bottom: 18px;
  -ms-grid-row: 2;

  &__nav-multicolumn {
    @include grid-rows(9);
    @include grid-ie11-fix(2);
  }

  &__nav-link {
    display: block;
    color: $color-white;
    opacity: .6;
    margin-bottom: 15px;
    font-size: $font-size-nav;
    transition: all .35s;

    &:hover {
      text-decoration: underline;
      opacity: .7;
    }

    &--main {
      display: block;
      margin-bottom: 25px;
      color: $color-white;
      transition: all .35s;

      &:hover {
        text-decoration: underline;
        opacity: .7;
      }
    }

    &--no-margin {
      margin: 0;
    }

    .nav__no-margin {
      margin: 0;
    }
  }
}
</style>
